import { Box } from "@mui/material";
import ContentCutIcon from "@mui/icons-material/ContentCut";

export default function TVFMLoader() {
    return (
        <Box
            sx={{
                position: "fixed",
                inset: 0,
                zIndex: 99999,

                display: "flex",
                justifyContent: "center",
                alignItems: "center",

                background: "transparent",
                backdropFilter: "blur(6px)",
            }}
        >
            {/* Soft Background Glow */}
            <Box
                sx={{
                    position: "absolute",

                    width: 220,
                    height: 220,

                    borderRadius: "50%",

                    background: `
                        radial-gradient(
                            circle,
                            rgba(196,69,105,.25) 0%,
                            rgba(139,30,45,.15) 40%,
                            transparent 75%
                        )
                    `,

                    filter: "blur(35px)",

                    animation: "glowPulse 2.5s infinite ease-in-out",

                    "@keyframes glowPulse": {
                        "0%,100%": {
                            transform: "scale(1)",
                        },
                        "50%": {
                            transform: "scale(1.2)",
                        },
                    },
                }}
            />

            {/* Loader Ring */}
            <Box
                sx={{
                    position: "absolute",

                    width: 130,
                    height: 130,

                    borderRadius: "50%",

                    border: "3px solid rgba(255,255,255,.12)",
                    borderTop: "3px solid #C44569",

                    animation:
                        "spin 1.2s linear infinite",

                    "@keyframes spin": {
                        from: {
                            transform: "rotate(0deg)",
                        },
                        to: {
                            transform: "rotate(360deg)",
                        },
                    },
                }}
            />

            {/* Metallic Scissor */}
            <Box
                sx={{
                    position: "relative",

                    animation:
                        "scissorPulse 1.8s infinite ease-in-out",

                    "@keyframes scissorPulse": {
                        "0%,100%": {
                            transform: "scale(1)",
                        },
                        "50%": {
                            transform: "scale(1.12)",
                        },
                    },
                }}
            >
                <ContentCutIcon
                    sx={{
                        fontSize: 60,

                        background:
                            "linear-gradient(145deg,#ffffff,#d9d9d9,#bfbfbf,#f5f5f5)",

                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",

                        filter: `
                            drop-shadow(0 0 6px rgba(255,255,255,.8))
                            drop-shadow(0 0 15px #C44569)
                            drop-shadow(0 0 30px rgba(196,69,105,.5))
                        `,
                    }}
                />
            </Box>
        </Box>
    );
}